<!--
/*******************************************************************************
*@ 컴포넌트명   : TrsaccGroupAcnoTab.vue
*@ 컴포넌트설명 : 당행이체 - 입금계좌번호 (직접입력)
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <div class="form">
      <mnrcv-acno
        ref="mnrcvAcno"
        inAcnKnd="1"
        inAcnDtlKnd="2"
        :value.sync="account"
        obaobDstcd="1"
        page="transfer"
      />
    </div>
    <modal-pop :opened.sync="openedError" class="modal" confirm="MCOM-0000003">
      <template #content>{{errMsg}}</template>
    </modal-pop>
  </article>
</template>

<script>
import MnrcvAcno from "@/components/page/common/MnrcvAcno";

export default {
  components: {
    MnrcvAcno,
  },
  mounted() {},
  data() {
    return {
      account: [],
      openedError: false, //오류알림 팝업
    };
  },
  computed: {
    accountData: {
      get() {
        return this.account;
      },
      set(value) {
        if (_.isEqual(value, "")) {
          this.mnrcvAcno = value;
          this.mnrcvAcnoAls = value;
          this.cncycd = value;
        } else {
          this.mnrcvAcno = _.split(value, ";")[0];
          this.mnrcvAcnoAls = _.split(value, ";")[2];
          this.cncycd = _.split(value, ";")[1];
        }

        this.account = value;
      },
    },
  },
  methods: {
    async getAcnoInfo() {
      let mnrcvInfo = await this.$refs.mnrcvAcno.getAcnoInfoAsync();

      if (!_.isEmpty(mnrcvInfo.acno)) {
        return { acno: mnrcvInfo.acno, acnoAls: mnrcvInfo.alias, cncycd: mnrcvInfo.cncycd };
      } else {
        this.errMsg = this.$t("MPAY-01-01-03-10"); //입력하신 번호는 유효하지 않은 계좌번호입니다.
        this.openedError = true;

        return {
          acno: "",
          acnoAls: "",
          cncycd: "",
        };
      }
    },
    setAcno(acno) {
      this.$refs.mnrcvAcno.setText(acno);
    },
  },
};
</script>